module.exports = __webpack_public_path__ + "static/media/volume_up-24px.aed75bc0.svg";